import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import ImageGalleryUploader from 'components/ImageGalleryUploader';

const ImageGalleryUploaderWidget = (props) => {
  const { value = [], onChange, label, formContext, name } = props;
  const s3Prefix = formContext[`${name}Prefix`];

  if (!s3Prefix) {
    return <div>Please set s3Prefix in formContext</div>;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <Typography variant="body2" color='textSecondary'>
        {label}
      </Typography>
      <ImageGalleryUploader
        s3Prefix={s3Prefix}
        s3Keys={value}
        onUpdateS3Keys={onChange}
      />
    </Box>
  );
};

ImageGalleryUploaderWidget.propTypes = {
  label: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  formContext: PropTypes.object,
  name: PropTypes.string,
};

export default ImageGalleryUploaderWidget;
